import { createRoute } from '@tanstack/react-router'

import CustomerAdd from '../pages/CustomerAdd'
import { customerRoute } from './CustomerRoute'

export const customerCreateRoute = createRoute({
  getParentRoute: () => customerRoute,
  component: () => <CustomerAdd />,
  path: '/create'
})
